import React from "react";

import { useTranslation } from "react-i18next";

import Button from "@/components/Button";

interface SuccessViewProps {
  conciergePlusUrl: string | null;
  timer: number;
  onOpenConciergePlus: () => void;
  onReset: () => void;
}

const SuccessView: React.FC<SuccessViewProps> = ({
  conciergePlusUrl,
  timer,
  onOpenConciergePlus,
  onReset,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold mt-20 uppercase text-center">
        {t("survey.success")}
      </h1>

      {conciergePlusUrl && (
        <p className="text-center mt-6">{t("survey.conciergePlus.redirect")}</p>
      )}

      {conciergePlusUrl && (
        <div className="flex justify-center mt-6">
          <Button
            onClick={onOpenConciergePlus}
            design="white"
            className="border-2 border-blue"
          >
            {t("survey.conciergePlus.open")}
          </Button>
        </div>
      )}

      <div className="flex justify-center mt-20">
        <Button onClick={onReset}>
          {t("survey.resetTimer", { seconds: timer })}
        </Button>
      </div>
    </div>
  );
};

export default SuccessView;
